import { PutManualSimulationAllotment } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 労務山積計算-登録・更新API
 */
export class SimulationYamadumiGateway {
  static putSimulationYamadumi = async (
    putManualSimulationAllotmentRes: PutManualSimulationAllotment
  ) => {
    const params = putManualSimulationAllotmentRes
    return await yamadumiApi.put<PutManualSimulationAllotment>(
      '/api/simulation/yamadumi',
      { ...params }
    )
  }
}
